/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  StockProductOptions.tsx
*
* Project Title :  Checkout
*
* Description	: Purchase Software page
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H175591
*
* @Date		    : Oct 1, 2019
*
* @Version      : Version 1.0
*
* By            : H224423
* On            : Oct 10, 2019
* Description   : ASDS-1478 - Grid level resposnive changes and UI issue fixes
******************************************************************************/
import React from 'react';
import { Grid, Button } from '@scuf/common';

/**
* @description Displays ADD To Cart button.
*/
export function StockProductOptions(props: any) {
    return (
        <Grid.Row className="fullwidthRow">
            <Grid.Column className="spo-add-to-cart">
                <Button type="primary" content="Add to Cart" size="small" className="pull-right co-primary-button" onClick={() => props.addToCartButtonClicked(props.product, props.system, props.categoryName)} />
            </Grid.Column>
        </Grid.Row>
    );
}

export default StockProductOptions;